import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});
const head = { "Content-Type": "multipart/form-data" };

const instance2 = axios.create({
  baseURL: apihostname,
  headers: { ...authHeader(), ...head },
});

class UserService {
  newPass(id, req) {
    return instance.put("/users/new", req, {
      params: {
        id: id,
      },
    });
  }
  updateUserprofile(id, req) {
    return instance2.post("/users/profile/" + id, req);
  }
  getUserprofile(id) {
    return instance.get("/users/profile/" + id);
  }
  deleteUser(id) {
    return instance.delete("/users/profile/" + id);
  }
  getFactorylist() {
    return instance.get("/factory");
  }

  getAcademylist() {
    return instance.get("/academy");
  }

  getOcsb() {
    return instance.get("/ocsb");
  }
  getUserlist() {
    return instance.get("/users/list");
  }
  createUser(body) {
    // console.log(body);
    return instance2.post("/users/new", body);
  }
  changeStatus(body) {
    // console.log(body);
    return instance.post("/users/change-status", body);
  }
  getRegionlist() {
    return instance.get("/region");
  }
  listRoles() {
    return instance.get("/users/list-roles");
  }
}

export default new UserService();
